import { useIsBusinessUser } from '../common/src/hooks/usersHooks'
import { useShouldDisplayUpgrade } from './userHooks'

/**
 * Hook to determine if the current user can access restricted projects feature
 * Business users (premium level >= 2) have access to restricted projects
 */
export const useCanAccessRestrictedProjects = () => {
  const isBusinessUser = useIsBusinessUser()
  return isBusinessUser
}

/**
 * Hook to determine if we should show restricted projects upgrade prompts
 * Shows prompts for non-business users who should see upgrade options
 */
export const useRestrictedProjectsUpgradePrompt = () => {
  const canAccess = useCanAccessRestrictedProjects()
  const shouldShowUpgrade = useShouldDisplayUpgrade()
  return !canAccess && shouldShowUpgrade
}

/**
 * Hook to determine if we should show feature discovery hints
 * Occasionally shows hints to free users about business features
 */
export const useShowRestrictedProjectsDiscovery = () => {
  const canAccess = useCanAccessRestrictedProjects()
  const shouldShowUpgrade = useShouldDisplayUpgrade()
  // Show discovery hints to 20% of free users to avoid overwhelming
  const showDiscovery = !canAccess && shouldShowUpgrade && Math.random() < 0.2
  return showDiscovery
}